module.exports = __webpack_public_path__ + "img/home.ebf33ea2.jpg";